import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

const FORM_URL = "https://readdy.ai/api/form/dahft0boh653ivfvntp0";

const INTERESTS = ["带货翻车", "情感纠纷", "人设争议", "版权抄袭", "直播风波", "全部方向"];

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status !== "success") {
      return;
    }
    const timer = window.setTimeout(() => setVisible(false), 4000);
    setVisible(true);
    return () => window.clearTimeout(timer);
  }, [status]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("contact_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    formData.delete("contact_alt");

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      payload.append(key, String(value));
    });

    setStatus("loading");
    setErrorMsg("");
    try {
      const response = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: {
        code?: string;
        message?: string;
        meta?: { message?: string; detail?: string };
      } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam = /spam/i.test(String(serverMsg)) || /spam/i.test(responseText);
      const isOk = response.ok && parsed?.code === "OK" && !isSpam;

      if (!isOk) {
        setStatus("error");
        setErrorMsg(serverMsg ? `提交未成功：${serverMsg}` : "提交未成功，请稍后重试。");
        return;
      }

      setStatus("success");
      form.reset();
    } catch {
      setStatus("error");
      setErrorMsg("网络异常，请稍后重试。");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      method="post"
      action={FORM_URL}
      data-readdy-form
      className="w-full"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <label className="sr-only" htmlFor="subscriber-email">
          邮箱地址
        </label>
        <input
          id="subscriber-email"
          name="email"
          type="email"
          required
          placeholder="输入邮箱，接收事件更新"
          className="h-12 w-full rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200"
        />
        <label className="sr-only" htmlFor="subscriber-interest">
          关注方向
        </label>
        <select
          id="subscriber-interest"
          name="interest"
          defaultValue="全部方向"
          className="h-12 w-full cursor-pointer rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-900 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200 sm:w-40"
        >
          {INTERESTS.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
        <button
          type="submit"
          disabled={status === "loading"}
          className="h-12 whitespace-nowrap rounded-md bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "订阅更新"}
        </button>
      </div>

      <input
        type="text"
        name="contact_alt"
        className="subscriber-extra-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />

      <div className="mt-3 min-h-[20px] text-xs" aria-live="polite">
        {status === "success" && visible && (
          <span className="text-secondary-700">
            订阅成功，新的事件复盘会第一时间发到你的邮箱。
          </span>
        )}
        {status === "error" && <span className="text-primary-700">{errorMsg}</span>}
        {status === "idle" && (
          <span className="text-foreground-400">
            我们只发送事件更新，不会用于其他用途。随时可以退订。
          </span>
        )}
      </div>
      <p className="mt-2 text-xs text-foreground-400">
        如需直接联系我们，可发送邮件至 {siteInfo.email}
      </p>
    </form>
  );
}